export const CUSTOMER_LOYALTY_COMPONENT_TYPE = {
	ESPOT: 'ESPOT',
	LEVEL: 'LEVEL',
	USER: 'USER',
};

export const PROGRESS_BAR_COLORS = {
	UNCOMPLETED: '#dfe6e9',
	COMPLETED: '#000000',
};
